<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/procurement-management/supplier-details"
          ></back-button>
          Add Supplier Detail
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/procurement-management/supplier-details`"
              >Supplier Details</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->

    <!-- Form  -->
    <div class="row">
      <div class="col-md-11 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  href="#home"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                  >General</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  href="#profile"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                  >Contact Person</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="contact-tab"
                  data-bs-toggle="tab"
                  href="#contact"
                  role="tab"
                  aria-controls="contact"
                  aria-selected="false"
                  >Bank Details</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For General Sectiion -->
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Supplier Code</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.supplier_code"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Supplier Code"
                          readonly
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Name</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.name"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Name"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Supplier Type</label
                      >
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.supplier_type_id"
                          :suggestions="supplierTypes"
                          placeholder="Select supplier type"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row mb-8" style="padding-left: 10px">
                          <label class="col-sm-9 col-form-label"
                            >Is Blacklisted</label
                          >
                          <div class="form-check form-switch">
                            <input
                              type="checkbox"
                              v-model="form.is_blacklisted"
                              class="form-check-input"
                              id="formSwitch1"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row mb-2">
                          <label class="col-sm-12 col-form-label"
                            >Is MSME</label
                          >
                          <div class="form-check form-switch mb-1">
                            <input
                              type="checkbox"
                              v-model="form.is_msme"
                              class="form-check-input"
                              id="formSwitch2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Rating</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.rating_id"
                          :suggestions="ratings"
                          placeholder="Select rating"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="row mb-2">
                      <label class="col-sm-2 col-form-label">Address</label>
                      <div class="col-sm-10">
                        <input
                          type="text"
                          v-model="form.address"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Address"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-2">
                      <label class="col-sm-2 col-form-label">City Name</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.city_name"
                          class="form-control"
                          autocomplete="off"
                          placeholder="City Name"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">State</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.state"
                          class="form-control"
                          autocomplete="off"
                          placeholder="State"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="row mb-2">
                      <label class="col-sm-2 col-form-label">Country</label>
                      <div class="col-sm-10">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.country_id"
                          :suggestions="countries"
                          placeholder="Select country"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-2">
                      <label class="col-sm-2 col-form-label">Credit term</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.credit_term"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Credit term"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Phone</label>
                      <div class="col-sm-9">
                        <!-- <textarea class="form-control" id="exampleFormControlTextarea1" rows="5"></textarea> -->
                        <input
                          type="text"
                          v-model="form.phone"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Phone"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Phone 1</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.phone1"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Phone 1"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label"
                        >Supplier Speciality</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.supplier_speciality"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Supplier Speciality"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Gst Number</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.gst_no"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Gst Number"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Phone 2</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.phone2"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Phone 2"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Fax</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.fax"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Fax"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Remarks</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.remarks"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Remarks"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Attachment</label>
                      <div class="col-sm-9">
                        <input
                          type="file"
                          name="attachment"
                          ref="file"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Attachment"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Website</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.website"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Website"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Email</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.email"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Email"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Email 1</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.email1"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Email 1"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Email 2</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.email2"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Email 1"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Date Of Registry</label
                      >
                      <div class="col-sm-9">
                        <my-datepicker
                          :date.sync="form.registery_date"
                          placeholder="Enter Registry Date"
                        ></my-datepicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label"
                        >validity Of License</label
                      >
                      <div class="col-sm-9">
                        <my-datepicker
                          :date.sync="form.validate_license_date"
                          placeholder="Enter Expiry Date"
                        ></my-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / General Section -->
              <!--  For Supplier Contact Section -->
              <div
                class="tab-pane fade"
                id="profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <div class="table-responsive">
                  <table id="dataTableExample" class="table table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile Number</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table
                        :isLoading="isLoading"
                        cols="5"
                      ></loading-table>
                      <tr v-if="form.supplier_contacts.length == 0">
                        <td colspan="5" class="text-center">No data Found</td>
                      </tr>
                      <tr
                        v-for="(supplier_contact, ar) in form.supplier_contacts"
                        :key="`supplier_contact${ar}`"
                      >
                        <td>{{ ar + 1 }}.</td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Name"
                            v-model="supplier_contact.name"
                          />
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Email"
                            v-model="supplier_contact.email"
                          />
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Mobile Number"
                            v-model="supplier_contact.mobile_no"
                          />
                        </td>
                        <td>
                          <div class="text-center">
                            <button
                              class="btn btn-danger btn-sm"
                              @click="deleteSupplierContact(supplier_contact)"
                              v-if="!supplier_contact.id"
                            >
                              Delete
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              @click="delete_contact_data(supplier_contact.id)"
                              v-else
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="form.supplier_contacts">
                        <td
                          colspan="5"
                          align="center"
                          @click="addEmptySupplierContact()"
                          style="
                            background-color: #6571ff;
                            color: white;
                            border-radius: 10px;
                            box-shadow: none;
                          "
                        >
                          Add New Row
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- /Table -->
                </div>
              </div>
              <!--  / For Supplier Contact Section -->
              <!--  For Bank Details Section -->
              <div
                class="tab-pane fade"
                id="contact"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                <div class="table-responsive">
                  <table id="dataTableExample" class="table table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Bank Name</th>
                        <th>Branch Name</th>
                        <th>IBAN / Account Number</th>
                        <th>City</th>
                        <th>Country</th>
                        <th>Account Type</th>
                        <th>IFSC</th>
                        <th>Swift Code</th>
                        <th>Payment Mode</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table
                        :isLoading="isLoading"
                        cols="11"
                      ></loading-table>
                      <tr v-if="form.supplier_bank_details.length == 0">
                        <td colspan="11" class="text-center">No data Found</td>
                      </tr>
                      <tr
                        v-for="(
                          supplier_bank_detail, ar
                        ) in form.supplier_bank_details"
                        :key="`supplier_bank_detail${ar}`"
                      >
                        <td>{{ ar + 1 }}.</td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Bank Name"
                            v-model="supplier_bank_detail.bank_name"
                          />
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Branch Name"
                            v-model="supplier_bank_detail.branch_name"
                          />
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="IBAN / Account Number"
                            v-model="supplier_bank_detail.iban_account_no"
                          />
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="City"
                            v-model="supplier_bank_detail.city"
                          />
                        </td>
                        <td>
                          <my-select
                            disableFormControl="true"
                            :selection.sync="supplier_bank_detail.country_id"
                            :suggestions="countries"
                            placeholder="Select country"
                          ></my-select>
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Account Type"
                            v-model="supplier_bank_detail.account_type"
                          />
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="IFSC"
                            v-model="supplier_bank_detail.ifsc"
                          />
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Swift Code"
                            v-model="supplier_bank_detail.swift_code"
                          />
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Payment Mode"
                            v-model="supplier_bank_detail.payment_mode"
                          />
                        </td>
                        <td>
                          <div class="text-center">
                            <button
                              class="btn btn-danger btn-sm"
                              @click="
                                deleteSupplierBankDetails(supplier_bank_detail)
                              "
                              v-if="!supplier_bank_detail.id"
                            >
                              Delete
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              @click="
                                delete_bank_details_data(
                                  supplier_bank_detail.id
                                )
                              "
                              v-else
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="form.supplier_bank_details">
                        <td
                          colspan="11"
                          align="center"
                          @click="addEmptyBankDetail()"
                          style="
                            background-color: #6571ff;
                            color: white;
                            border-radius: 10px;
                            box-shadow: none;
                          "
                        >
                          Add New Row
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- /Table -->
                </div>
              </div>
              <!--  / Supplier Contact Section -->
            </div>
            <!-- /Tab -->
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";

export default {
  name: "SupplierDetailCreate",
  data() {
    return {
      form: {
        country_id: "",
        rating_id: "",
        supplier_type_id: "",
        supplier_contacts: [],
        supplier_bank_details: [],
      },
      countries: [],
      supplierTypes: [],
      ratings: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("supplier_details/masters");
      masters = masters.data;
      masters.countries.forEach((country) => {
        this.countries.push({
          id: country.id,
          name: country.name,
        });
      });
      masters.supplier_types.forEach((supplier_type) => {
        this.supplierTypes.push({
          id: supplier_type.id,
          name: supplier_type.name,
        });
      });
      masters.ratings.forEach((rating) => {
        this.ratings.push({
          id: rating.id,
          name: rating.name,
        });
      });
    },
    async save() {
      try {
        console.log(this.form);
        this.isLoading = true;
        await axios.post("/supplier_details", this.form);
        this.isLoading = false;
        this.$router.push("/procurement-management/supplier-details");
      } catch (e) {
        this.isLoading = false;
      }
    },
    deleteSupplierContact(supplierDetail) {
      this.form.supplier_contacts = this.form.supplier_contacts.filter(
        (ar) => ar != supplierDetail
      );
    },
    addEmptySupplierContact() {
      this.form.supplier_contacts.push({
        // supplier_detail_id: this.form.id,
        company_id: this.company.id,
        name: "",
        email: "",
        mobile_no: "",
      });
    },
    async delete_contact_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=supplier_contacts`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
    deleteSupplierBankDetails(bankDetail) {
      this.form.supplier_bank_details = this.form.supplier_bank_details.filter(
        (ar) => ar != bankDetail
      );
    },
    addEmptyBankDetail() {
      this.form.supplier_bank_details.push({
        // supplier_detail_id: this.form.id,
        company_id: this.company.id,
        bank_name: "",
        branch_name: "",
        iban_account_no: "",
        city: "",
        country_id: "",
        account_type: "",
        ifsc: "",
        swift_code: "",
        payment_mode: "",
      });
    },
    async delete_bank_details_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=supplier_bank_details`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
